import type { SocialItem } from "../types/content";

export function sanitizePhoneNumber(phone: string): string {
  return phone.replace(/[^+\d]/g, "");
}

export function buildTelHref(phone?: string): string | undefined {
  if (!phone) return undefined;
  const cleaned: string = sanitizePhoneNumber(phone);
  if (!cleaned) return undefined;
  return `tel:${cleaned}`;
}

export function formatWhatsAppNumber(phone: string): string {
  let num = phone.replace(/[\s\-()+]/g, "");
  num = num.replace(/^0+/, "");
  return num;
}

export function buildWhatsappHref(social: SocialItem[], phone?: string): string | undefined {
  const whatsappItem: SocialItem | undefined = social.find((item) =>
    item.icon.toLowerCase() === "whatsapp" || item.name.toLowerCase().includes("whats")
  );
  if (whatsappItem) return whatsappItem.url;
  if (!phone) return undefined;
  const digitsOnly: string = sanitizePhoneNumber(phone).replace(/^\+/, "");
  if (!digitsOnly) return undefined;
  return `https://wa.me/${digitsOnly}`;
}
